import { Component, ElementRef, OnInit } from '@angular/core';
import { AuthService } from './auth.service'
import { Router, ActivatedRoute} from '@angular/router';
import {LoadingIndicator} from '../shared/loading-indicator';
import { UserSession } from '../shared/user-session';
import { UserInfoService } from '../shared/user-info.service';
import { Http, Response, RequestOptionsArgs, Headers } from '@angular/http';
import * as _ from 'lodash';

@Component({
    //providers: [AuthService],
    directives: [LoadingIndicator],
    //templateUrl: 'app/authentication/login.component.html'
    template: require('./login.component.html'),
})



export class LoginComponent implements OnInit {

    public alerts: any[];
    public loggingIn: boolean;
    public userName: string;
    public userPassword: string;
    
    public userNameFocus = true;
    private sub: any;
    private suboidc: any;
    public requestedUrl: string ='';
    public oidcCode: string ='';


    constructor(private router: Router,
        private authService: AuthService, 
        private route: ActivatedRoute,                
        private User: UserSession, 
        private _userInfoService: UserInfoService) {}    
 
    ngOnInit() : void{
       //console.log(this.route.queryParams);
       

        this.sub = this.route.params.subscribe(
            params => {
                this.requestedUrl = params['requestedUrl'];
        });

        this.suboidc = this.route.queryParams.subscribe(
            params => {
                let oidcCode = params['code'];
                if(!_.isEmpty(oidcCode) && !this.loggingIn && !this.authService.isLoggedIn()){
                    this.login(oidcCode)
                }

        });

        if(this.authService.isLoggedIn()){
            this.router.navigate(['/welcome']);
        }
    }

    loginoidc(){
        this.authService.oidclogin();
    }

    login(oidcCode: string) {
        this.loggingIn = true;

        this.authService.login(oidcCode)
            .subscribe(
                success => {
                    this.User.updateSessionState();
                    // this.ngOnInit();
                    if(this.requestedUrl){
                        this.router.navigate([this.requestedUrl]);
                    }
                    else{
                        this.router.navigate(['/welcome']);
                    }
                    window.location.reload();
                  
                },
                error => {
                    console.log("LOGIN ERROR:",JSON.stringify(error,null,2));
                    this.alerts = [];		
					this.alerts.push({type: 'danger', msg: error.error_description || 'Error Connecting to Server' });
                    this.loggingIn = false
                }
            );
    }

    closeAlert(index: number) {
        this.alerts.splice(index, 1);
  	}
}



/** WEBPACK FOOTER **
 ** ./app/authentication/login.component.ts
 **/